






















































































































































































import VueI18n from "vue-i18n";
import { Component, Vue, Watch } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import {
  ShipmentCertificatesApi,
  ShipmentCertificatesApiGetShipmentCertificateByKeywordRequest,
} from "../../../../apis";
import ShipmentConfirmDialog from "../../shipment/ShipmentConfirmDialog.vue";
import { IAction } from "../../common/CommonTypes";
import MoreVertBtn from "../../common/MoreVertBtn.vue";
import { ACTION, STATUS as STATUS_CERTIFICATE } from "../../shipment/index";
import moment from "moment";
import { VueExcelEco2 } from "../../common/VueExcelEco2";

@Component({
  components: { MoreVertBtn, ShipmentConfirmDialog },
})
export default class ShipmentCertificate extends Vue {
  screenWidth: number = window.innerWidth;
  private _resizeListener: (() => void) | null = null;

  get STATUS() {
    const statusOptions = [
      { value: "", name: this.$t("text.all") },
      { value: STATUS_CERTIFICATE.VALID, name: this.$t("status.VALID") },
      { value: STATUS_CERTIFICATE.ACCEPTED, name: this.$t("status.ACCEPTED") },
      { value: STATUS_CERTIFICATE.APPROVED, name: this.$t("status.APPROVED") },
      { value: STATUS_CERTIFICATE.REJECTED, name: this.$t("status.REJECTED") },
      {
        value: STATUS_CERTIFICATE.NEED_SUPPORT,
        name: this.$t("status.NEEDSUPPORT"),
      },
      { value: STATUS_CERTIFICATE.CANCELED, name: this.$t("status.CANCELED") },
    ];
    return statusOptions;
  }

  selectedShipment = {} as any;
  mode: ACTION = null;
  items = [];
  selectedAction: ACTION;

  readonly VIEW_ACTION: IAction = {
    titleName: this.$t("text.view"),
    action: ACTION.VIEW,
    permission: { context: "SHIPMENT_CERTIFICATE_REPORTS", action: "read" },
  };

  readonly EDIT_ACTION: IAction = {
    titleName: this.$t("text.edit"),
    action: ACTION.EDIT,
    permission: { context: "SHIPMENT_CERTIFICATE_REPORTS", action: "update" },
  };

  readonly SEND_ACTION: IAction = {
    titleName: this.$t("text.send"),
    action: ACTION.SEND,
    permission: { context: "SHIPMENT_CERTIFICATE_REPORTS", action: "update" },
  };

  readonly SENDAGAIN_ACTION: IAction = {
    titleName: this.$t("text.sendAgain"),
    action: ACTION.SENDAGAIN,
    permission: { context: "SHIPMENT_CERTIFICATE_REPORTS", action: "update" },
  };

  readonly DELETE_ACTION: IAction = {
    titleName: this.$t("text.delete"),
    action: ACTION.DELETE,
    titleStyle: "color: red",
    permission: { context: "SHIPMENT_CERTIFICATE_REPORTS", action: "delete" },
  };

  readonly VIEWCERTIFICATE_ACTION: IAction = {
    titleName: this.$t("text.viewCertificate"),
    action: ACTION.VIEWCERTIFICATE,
    permission: { context: "SHIPMENT_CERTIFICATE_REPORTS", action: "read" },
  };

  readonly APPROVE_ACTION: IAction = {
    titleName: this.$t("text.approve"),
    action: ACTION.APPROVED,
    titleStyle: "color: green",
    permission: {
      context: "SHIPMENT_CERTIFICATE_REPORTS|APPROVE_REJECT",
      action: "update",
    },
  };

  readonly REJECT_ACTION: IAction = {
    titleName: this.$t("text.reject"),
    action: ACTION.REJECTED,
    titleStyle: "color: red",
    permission: {
      context: "SHIPMENT_CERTIFICATE_REPORTS|APPROVE_REJECT",
      action: "update",
    },
  };

  readonly CANCEL_ACTION: IAction = {
    titleName: this.$t("text.cancel"),
    titleStyle: "color: red",
    action: ACTION.CANCEL,
    permission: { context: "SHIPMENT_CERTIFICATE_REPORTS", action: "update" },
  };

  pagingOption: DataOptions | null = null;
  totalRecord: number = 0;

  searchParam = {
    keyword: "",
    status: "",
    dateFrom: "",
    dateTo: "",
  };

  confirmContent: string | VueI18n.TranslateResult = "";
  showConfirmDialog = false;

  get isClient() {
    return this.$util.isClient();
  }
  dataExport = [];

  get HEADERS() {
    const headers = [
      {
        text: this.$t("text.location"),
        value: "location.locationName",
        class: [
          "column-sticky",
          this.$store.getters.locale === "vi" ? "w-88" : "w-80",
        ],
        cellClass: [
          "column-sticky",
          this.$store.getters.locale === "vi" ? "w-88" : "w-80",
        ],
      },
      {
        text: this.$t("text.certificateId"),
        value: "certificateId",
        class: ["tw-whitespace-no-wrap", "tw-p-4", "column-sticky", 'mw-70'],
        cellClass: ["column-sticky", 'mw-70'],
      },
      {
        text: this.$t("text.customer"),
        value: "customer.companyName",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.product"),
        value: "product.treatmentName",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.treatmentId"),
        value: "treatmentId",
        class: ["tw-p-4"],
        cellClass: [],
        width: 30,
        sortable: false,
      },
      {
        text: this.$t("text.totalRequestWeight"),
        value: "totalRequestWeights",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.totalRemainingWeight"),
        value: "totalUncertificatedWeight",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.desiredIssueDate"),
        value: "desiredIssueDate",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.fee"),
        value: "fee",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.originals"),
        value: "originals",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      // {
      //   text: this.$t("text.bill"),
      //   value: "bill",
      //   class: ["tw-whitespace-no-wrap", "tw-p-4"],
      //   cellClass: ["tw-whitespace-no-wrap"],
      // },
      {
        text: this.$t("text.sealno"),
        value: "containerOrSealNo",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.blno"),
        value: "bLNo",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.vesselname"),
        value: "vesselName",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.status"),
        value: "status",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.action"),
        value: "action",
        class: ["tw-whitespace-no-wrap", "tw-p-4"],
        cellClass: ["tw-whitespace-no-wrap"],
        sortable: false,
      },
    ] as DataTableHeader[];
    if (this.$util.isClient()) {
      this.lodash.remove(headers, { value: "customer.companyName" });
      this.lodash.remove(headers, { value: "fee" });
      // this.lodash.remove(headers, { value: "bill" });
    }
    return headers;
  }
  get isWideScreen(): boolean {
    return this.screenWidth > 600;
  }

  get filteredHeaders() {
    const excludeHeaders = this.isWideScreen
      ? []
      : [
          "product.treatmentName",
          "totalRequestWeights",
          "totalUncertificatedWeight",
          "desiredIssueDate",
          "fee",
          "originals",
          "containerOrSealNo",
          "bLNo",
          "vesselName",
          "status",
        ];
    return this.HEADERS.filter((h) => !excludeHeaders.includes(h.value));
  }
  isShowFilter: boolean = false;
  isFilter: boolean = false;
  private __initialFilter__: Record<string, any> = {};
  private __excludeKeys__: string[] = [];

  setInitialFilter(
    currentFilter: Record<string, any>,
    excludeKeys: string[] = []
  ) {
    this.__initialFilter__ = JSON.parse(JSON.stringify(currentFilter));
    this.__excludeKeys__ = JSON.parse(JSON.stringify(excludeKeys)) || [];
  }

  hasFilterChanged(currentFilter: Record<string, any>): boolean {
    const filteredKeys = Object.keys(currentFilter).filter(
      (key) => !this.__excludeKeys__.includes(key)
    );
    return filteredKeys.some(
      (key) =>
        JSON.stringify(currentFilter[key]) !==
        JSON.stringify(this.__initialFilter__[key])
    );
  }

  mounted() {
    this.setInitialFilter(this.searchParam, ["keyword"]);

    const handleResize = () => {
      this.screenWidth = window.innerWidth;
    };

    window.addEventListener("resize", handleResize);

    this._resizeListener = handleResize;
  }

  beforeDestroy() {
    if (this._resizeListener) {
      window.removeEventListener("resize", this._resizeListener);
    }
  }

  updated() {
    this.frozenColumnsBuilder();
  }

  frozenColumnsBuilder() {
    const tableThs: any = document.querySelectorAll(
      ".shipment-certificate-table table thead tr th"
    );
    this.$nextTick(() => {
      if (!tableThs.length) return;

      const actionThIndex = tableThs.length - 1;
      const actionTh: any = document.querySelector(
        `.shipment-certificate-table table > thead > tr > th:nth-child(${
          actionThIndex + 1
        })`
      );
      const actionTds: any = document.querySelectorAll(
        `.shipment-certificate-table table > tbody > tr > td:nth-child(${
          actionThIndex + 1
        })`
      );
      if (actionTh) {
        actionTh.style.position = "sticky";
        actionTh.style.right = "0px";
        actionTh.style.backgroundColor = "#ffffff";
        actionTh.style.zIndex = "2";
        actionTh.style.setProperty(
          "box-shadow",
          "-2px 0 5px rgba(0,0,0,0.1)",
          "important"
        );
      }

      if (actionTds) {
        actionTds.forEach((td) => {
          td.style.position = "sticky";
          td.style.right = "0px";
          td.style.backgroundColor = "#ffffff";
          td.style.zIndex = "1";
          td.style.setProperty(
            "box-shadow",
            "-2px 0 5px rgba(0,0,0,0.1)",
            "important"
          );
        });
      }
      const locationNameTh: any = document.querySelector(
        `.shipment-certificate-table table > thead > tr > th:nth-child(1)`
      );
      const locationNameTds: any = document.querySelectorAll(
        `.shipment-certificate-table table > tbody > tr > td:nth-child(1)`
      );
      if (locationNameTh) {
        locationNameTh.style.position = "sticky";
        locationNameTh.style.left = "0px";
        locationNameTh.style.zIndex = "3";
      }
      if (locationNameTds) {
        locationNameTds.forEach((td) => {
          td.style.position = "sticky";
          td.style.left = "0px";
          td.style.width =
            this.$store.getters.locale === "vi" ? "88px" : "80px";
          td.style.zIndex = "2";
        });
      }

      const certificateTh: any = document.querySelector(
        `.shipment-certificate-table table > thead > tr > th:nth-child(2)`
      );
      const certificateTds: any = document.querySelectorAll(
        `.shipment-certificate-table table > tbody > tr > td:nth-child(2)`
      );

      if (certificateTh) {
        certificateTh.style.position = "sticky";
        certificateTh.style.left =
          this.$store.getters.locale === "vi" ? "88px" : "80px";
        certificateTh.style.zIndex = "3";
      }
      if (certificateTds) {
        certificateTds.forEach((td) => {
          td.style.position = "sticky";
          td.style.left = this.$store.getters.locale === "vi" ? "88px" : "80px";
          td.style.zIndex = "2";
        });
      }
    });
  }

  onAddShipment() {
    return this.$router.push({ name: "add-shipment" });
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }
  get exportClick() {
    return this.$store.getters.export;
  }
  get addLicenseClick() {
    return this.$store.getters.addLicenseClick;
  }
  @Watch("exportClick")
  onexportClick() {
    this.doExport();
  }
  async doExport() {
    const getValueOrUndefined = (value) => {
      return value ? value : undefined;
    };
    const startDate = this.searchParam.dateFrom
      ? moment(this.searchParam.dateFrom, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const endDate = this.searchParam.dateTo
      ? moment(this.searchParam.dateTo, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const body = {
      keyword: getValueOrUndefined(this.searchParam.keyword),
      status: getValueOrUndefined(this.searchParam.status),
      startDate: startDate,
      endDate: endDate,
      limit: null,
      page: 1,
      orderBy: getValueOrUndefined(this.pagingOption.sortBy[0]),
      orderDesc: getValueOrUndefined(this.pagingOption.sortDesc[0]),
    } as ShipmentCertificatesApiGetShipmentCertificateByKeywordRequest;
    const columnsExport = this.HEADERS.map((h) => {
      return { label: h.text, field: h.value };
    }).filter((h) => h.field != "action");
    try {
      this.$util.showLoading();
      const res =
        await new ShipmentCertificatesApi().getShipmentCertificateByKeyword(
          body
        );
      this.dataExport = res.data.data.map((r) => {
        const desiredIssueDate = r.desiredIssueDate
          ? this.$moment(r.desiredIssueDate).format("DD/MM/YYYY")
          : "-";
        return {
          ...r,
          desiredIssueDate: desiredIssueDate,
          treatmentId: this.lodash.join(
            this.lodash.uniq(
              r.shipmentTreatmentValue.map((val) => val.numberCode)
            ),
            "; "
          ),
        };
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      const data = this.lodash.reverse(this.dataExport);
      const exportExcel = new VueExcelEco2(
        "ECO2 - Export Shipment Request",
        "xlsx",
        "ECO2 Web",
        data,
        columnsExport
      ).exportExcel();
      this.$util.hideLoading();
    }
  }

  async onSearch() {
    await this.doSearch();
    this.isFilter = this.hasFilterChanged(this.searchParam);
  }

  onPagingOption() {
    this.onSearch();
  }

  async doSearch(): Promise<void> {
    if (this.$route.query.keyword) {
      this.searchParam.keyword = this.$route.query.keyword.toString();
    }
    const getValueOrUndefined = (value) => {
      return value ? value : undefined;
    };
    const startDate = this.searchParam.dateFrom
      ? moment(this.searchParam.dateFrom, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const endDate = this.searchParam.dateTo
      ? moment(this.searchParam.dateTo, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const body = {
      keyword: getValueOrUndefined(this.searchParam.keyword),
      status: getValueOrUndefined(this.searchParam.status),
      startDate: startDate,
      endDate: endDate,
      limit: this.pagingOption.itemsPerPage,
      page: this.pagingOption.page,
      orderBy: getValueOrUndefined(this.pagingOption.sortBy[0]),
      orderDesc: getValueOrUndefined(this.pagingOption.sortDesc[0]),
    } as ShipmentCertificatesApiGetShipmentCertificateByKeywordRequest;
    try {
      this.$util.showLoading();
      const res =
        await new ShipmentCertificatesApi().getShipmentCertificateByKeyword(
          body
        );
      this.items = res.data.data;
      this.totalRecord = res.data.count;
      if (this.$route.query.keyword) {
        this.$router.replace({ query: null });
      }
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  getColor(status: STATUS_CERTIFICATE) {
    if (
      status == STATUS_CERTIFICATE.ACCEPTED ||
      status == STATUS_CERTIFICATE.NEED_SUPPORT
    )
      return "#EEAE4E";
    if (
      status == STATUS_CERTIFICATE.REJECTED ||
      status == STATUS_CERTIFICATE.CANCELED
    )
      return "#E54949";
    else return "#00B162";
  }

  getStatusAction(status: STATUS_CERTIFICATE) {
    // client actions
    if (this.$util.isClient()) {
      return [this.VIEW_ACTION, this.VIEWCERTIFICATE_ACTION];
    }
    // admin actions
    switch (status) {
      case STATUS_CERTIFICATE.VALID:
      case STATUS_CERTIFICATE.ACCEPTED: {
        return [
          this.VIEW_ACTION,
          this.EDIT_ACTION,
          this.CANCEL_ACTION,
          this.VIEWCERTIFICATE_ACTION,
        ];
      }
      case STATUS_CERTIFICATE.NEED_SUPPORT: {
        return [this.APPROVE_ACTION, this.REJECT_ACTION, this.EDIT_ACTION];
      }
      case STATUS_CERTIFICATE.APPROVED: {
        return [
          this.VIEW_ACTION,
          this.EDIT_ACTION,
          this.CANCEL_ACTION,
          this.VIEWCERTIFICATE_ACTION,
        ];
      }
      case STATUS_CERTIFICATE.REJECTED:
      case STATUS_CERTIFICATE.CANCELED:
        break;
      default: {
        break;
      }
    }
  }

  async onSelectedAction(item, action) {
    this.selectedShipment = { ...item };
    this.selectedAction = action;
    switch (action) {
      case ACTION.VIEW: {
        this.$router.push({
          name: "shipment-detail",
          params: { id: this.selectedShipment.id },
          query: { from: "" },
        });
        break;
      }
      case ACTION.EDIT: {
        this.$router.push({
          name: "edit-shipment",
          params: { id: this.selectedShipment.id },
          query: { from: "" },
        });
        break;
      }
      case ACTION.APPROVED: {
        this.onApporve();
        break;
      }
      case ACTION.REJECTED: {
        this.onReject();
        break;
      }
      case ACTION.CANCEL: {
        this.onCancel();
        break;
      }
      case ACTION.VIEWCERTIFICATE: {
        this.$router.push({
          name: "certificate-export",
          params: { id: this.selectedShipment.id },
        });
        break;
      }
      default: {
        break;
      }
    }
  }

  onDelete() {
    this.showConfirmDialog = true;
    this.confirmContent = this.$t("dialog.delete.shipmentCertificate");
  }

  onSend() {
    this.showConfirmDialog = true;
    this.confirmContent = this.$t("dialog.send.shipmentCertificate");
  }

  onApporve() {
    this.showConfirmDialog = true;
    this.confirmContent = this.lodash.template(
      `${this.$t("dialog.approve.shipmentCertificate")}`
    )({ number: this.selectedShipment.certificateId });
  }

  onReject() {
    this.showConfirmDialog = true;
    this.confirmContent = this.lodash.template(
      `${this.$t("dialog.reject.shipmentCertificate")}`
    )({ number: this.selectedShipment.certificateId });
  }

  onCancel() {
    this.showConfirmDialog = true;
    this.confirmContent = this.lodash.template(
      `${this.$t("dialog.cancel.shipmentCertificate")}`
    )({ number: this.selectedShipment.certificateId });
  }

  remark: string = "";
  async onOkConfirmDialog(remark) {
    this.remark = remark;
    if (this.selectedAction === ACTION.APPROVED) {
      await this.doApprove();
    }
    if (this.selectedAction === ACTION.REJECTED) {
      await this.doReject();
    }
    if (this.selectedAction === ACTION.CANCEL) {
      await this.doCancel();
    }
    this.doSearch();
  }

  async doApprove() {
    this.$util.showLoading();
    try {
      await new ShipmentCertificatesApi().updateStatusShipmentCertificate({
        id: this.selectedShipment.id,
        action: "APPROVED",
        cancelRemarkShipmentCertificateRequest: {
          remark: this.remark,
        },
      });
      this.showConfirmDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async doReject() {
    this.$util.showLoading();
    try {
      await new ShipmentCertificatesApi().updateStatusShipmentCertificate({
        id: this.selectedShipment.id,
        action: "REJECTED",
        cancelRemarkShipmentCertificateRequest: {
          remark: this.remark,
        },
      });
      this.showConfirmDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async doCancel() {
    this.$util.showLoading();
    try {
      await new ShipmentCertificatesApi().updateStatusShipmentCertificate({
        id: this.selectedShipment.id,
        action: "CANCELED",
        cancelRemarkShipmentCertificateRequest: {
          remark: this.remark,
        },
      });
      this.showConfirmDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
